import { render, staticRenderFns } from "./PTW.vue?vue&type=template&id=ebeb5daa&scoped=true"
import script from "./PTW.vue?vue&type=script&lang=js"
export * from "./PTW.vue?vue&type=script&lang=js"
import style0 from "./PTW.vue?vue&type=style&index=0&id=ebeb5daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebeb5daa",
  null
  
)

export default component.exports